import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import * as React from 'react';
import { runwayColors } from '../styles/globalStyles';

export interface CharCounterProps {
    maxLength: number;
    minLength?: number;
    stringValue?: string;
}

export const CharCounter: React.FC<CharCounterProps> = ({ maxLength, minLength = 1, stringValue }) => {
    const charCount = stringValue?.length ?? 0;
    const characterCountValid = charCount <= maxLength && charCount >= minLength;

    return (
        <Space direction="vertical">
            <Typography.Text
                style={{
                    color: characterCountValid ? runwayColors.statusGrey : runwayColors.statusRed,
                }}
            >
                {charCount} / {maxLength}
            </Typography.Text>
        </Space>
    );
};
